import React from "react";
import {Table, Input, Button, Icon, Row, Col, message, Modal, Select, Card, Pagination, List, Divider, Tag , Spin} from 'antd';
import { Scrollbars } from 'react-custom-scrollbars';
import getSize from "../../../utils/getSize";
import NHFetch from "../../../utils/NHFetch";
import moment from 'moment';
import {createUuid,hasAuth} from "../../../utils/NHCore"
import NHTable from '../../common/NHTable';
import {NHModal, NHConfirm} from '../../common/NHModal';
import EditForm from './EditForm.js';
import SettingForm from './SettingForm.js';
import css from './index.css';


const confirm = Modal.confirm;
const Option = Select.Option;
const Search = Input.Search;

const baseUrlPath = "/fwwgl/cjwt"; //TODO 把此处的信息改成自己的

/**
 * 在线问答
 * @date 2018-03-02 14:00
 * Version: 1.0
 */
class ZxwdTab extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            spinLoading: false, //是否显示正在加载
            spinTip: '正在加载...', //耗时请求提示文字
            formInitData: {},
            showOperationBtn:false,
            clientHeight: document.documentElement.clientHeight,
            clientWidth: document.documentElement.clientWidth,
            data: [],
            sign: 'zhxg_yxxt_fwwgl_cjwt_queryPage',
            searchParams: {},
            searchTextMap: {},
            sqlParams: {wtda:'1=1'},
            searchField: 'multiField,wtflm,wt,twbm',//通用查询的字段
            searchText: '',//通用查询的值
            pageData: {
                total: 50,
                pageSize: 5,//当前页默认多少条数据
                page: 1
            },
            pageSizeOptions: ['5', '10', '15', '20'],
            getContent:undefined,//获取富文本编辑器的值
            wtfl:[]//问题分类选项
        };
    }

    getContent=(getContent)=>{
        this.setState({getContent:getContent});
    }

    componentDidMount() {
        window.addEventListener('resize', this.onWindowResize);
        this.wtflload();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.onWindowResize);
    }
    componentWillMount() {
        let width = this.state.clientWidth - 328;
        let height = this.state.clientHeight - 336;
        let w = parseInt(width / 137) > 1 ? parseInt(width / 137) : 1;
        let h = parseInt(height / 195) > 1 ? parseInt(height / 195) : 1;
        let pageSize = w * h;
        this.setState({
            // pageSizeOptions: [pageSize, pageSize * 2, pageSize * 3, pageSize * 4],
            pageData: {
                total: 50,
                pageSize: 5,//当前页默认多少条数据
                page: 1
            }
        }, this.filterData);

        // this.filterData();
    }
    onWindowResize = () => {
        const clientHeight = document.documentElement.clientHeight;
        const clientWidth = document.documentElement.clientWidth;
        this.setState({
            clientHeight: clientHeight,
            clientWidth: clientWidth,
        })
    }

    onShowSizeChange = (current, pageSize) => {
        this.setState({
            pageData: {
                pageSize: pageSize,
                page: current
            }
        }, () => {
            this.readData();
        });
    }
    //渲染状态码
    wtflload = ()=>{
        NHFetch("/proData/selectDataList","get",'sign=dmk_YXXT_WTFL')
            .then(res => {
                if(res){
                    this.setState({wtfl:res.data});
                }
            });
    };

    //获取学生信息
    getData = (params) => {
        this.setState({ spinLoading: true, spinTip: '正在初始化，请耐心等待...' });
        NHFetch("/proData/gridList", "POST", params).then(
            res => {
                if (res) {
                    if (res.data) {
                        this.setState({
                            data: res.data.list,
                            pageData: {
                                total: res.data.total,
                                pageSize: this.state.pageData.pageSize,
                                page: this.state.pageData.page
                            },
                            spinLoading: false
                        })
                    }
                }
            }
        )
    }


    //修改按钮点击事件
    handleUpdateBtnClick = (pkid) => {
        NHFetch(baseUrlPath + '/' + pkid + '/get' , 'GET')
            .then(res => {
                if(res){
                    this.setState({formInitData: res.data});
                    this.refs.nhUpdateModal.show();
                }
            })
    }

    //设置按钮点击事件
    handleSettingBtnClick = (pkid) => {
        NHFetch(baseUrlPath + '/' + pkid + '/get' , 'GET')
            .then(res => {
                if(res){
                    this.setState({formInitData: res.data});
                    this.refs.nhSettingModal.show();
                }
            })
    }
    //多行删除
    handleMultiDeleteBtnClick = () => {
        let selectedRowKeys = this.refs.nhTable.state.selectedRowKeys;
        if(selectedRowKeys && selectedRowKeys.length>0){
            NHConfirm("是否确定删除选中的多条数据？",() => {
                this.handleDelete(selectedRowKeys);
            },"warn");
        }else{
            message.warning("请先选择需要删除的数据！");
        }
    }
    //单行删除
    handleSingleDeleteBtnClick = (record) => {
       NHConfirm("是否确定删除这条数据？",() => {
           let pkid = record.PKID;
           this.handleDelete([pkid]);
       },"warn");
    }
    //多行删除
    handleMultiDeleteBtnClick = () => {
        let selectedRowKeys = this.refs.nhTable.state.selectedRowKeys;
        if(selectedRowKeys && selectedRowKeys.length>0){
            NHConfirm("是否确定删除选中的多条数据？",() => {
                this.handleDelete(selectedRowKeys);
            },"warn");
        }else{
            message.warning("请先选择需要删除的数据！");
        }
    }
    //删除操作
    handleDelete = (pkids) => {
        NHFetch(baseUrlPath + '/deleteByMulti' , 'POST' , [pkids])
            .then(res => {
                if (res) {
                    message.success("删除操作成功！");
                    //this.filterData();
                    this.readData();
                }
            })
    }
    deleteWt=(pkid)=>{
        console.log(pkid)
        NHConfirm("是否确定删除该问题？",() => {
            this.handleDelete(pkid);
        },"warn");
    }


    //回答问题保存方法
    handleSaveUpdate = () => {
        this.refs.nhUpdateForm.validateFields((err, formData) => {
            if (err) {
                return;
            }
            if(this.state.getContent) {
                formData.wtda = this.state.getContent();
            }
            NHFetch(baseUrlPath + '/update' , 'POST' , formData)
                .then(res => {
                    if (res) {
                        message.success("回答问题成功！");
                        this.refs.nhUpdateModal.close();
                        this.filterData();
                    }
                })
        });
    }

    //问题设置保存方法
    handleSettingUpdate = () => {
        this.refs.nhSettingForm.validateFields((err, formData) => {
            if (err) {
                return;
            }
            if(this.state.getContent) {
                formData.wtda = this.state.getContent();
            }
            NHFetch(baseUrlPath + '/update' , 'POST' , formData)
                .then(res => {
                    if (res) {
                        message.success("问题设置成功！");
                        this.refs.nhSettingModal.close();
                        this.filterData();
                    }
                })
        });
    }

    //重置操作
    onRest = () => {
        this.setState((prevState, props) => ({
            searchParams: {},//自定义的搜索条件
            searchText: '',
            pageData: {
                total: this.state.pageData.total,
                pageSize: this.state.pageData.pageSize,
                page: 1
            }
        }), function () {
            this.filterData();
        });
    }
    //重新加载数据数据的方法（从第一页开始）
    filterData = () => {
        this.setState((prevState, props) => ({
            pageData: {
                total: this.state.pageData.total,
                pageSize: this.state.pageData.pageSize,
                page: 1
            }
        }));
        this.readData();
    }
    //在当前页刷新数据
    readData = () => {
        let pagination = this.state.pageData;//分页的参数
        let searchParams = this.state.searchParams;//传递过来的查询参数
        let sqlParams = this.state.sqlParams;
        let searchTextMap = this.state.searchTextMap;
        if (!searchParams) { searchParams = {}; }
        let params = {
            pagination: pagination,
            sign: this.state.sign,
            filters: {},
            sorter: {},
            searchTextMap: searchTextMap,//下拉框查询的值,用作查询
            searchParams: searchParams,
            sqlParams: sqlParams,
            initParams: {},
            sign: this.state.sign
        };
        this.getData(params);
    }
    //问题分类下拉框
    wtflSearchFieldChange = (value) => {
        let searchTextMap = {};
        if(value == 'multiField'){
            this.setState({searchTextMap:searchTextMap})
        } else {
            searchTextMap['wtflm']=value;
            this.setState({searchTextMap:searchTextMap})
        }

    }
    //是否回答问题下拉框
    SearchFieldChange = (value) => {
        let sqlParams = {};
        if(value == 'multiField'){
            sqlParams['wtda']='1=1'
            this.setState({sqlParams:sqlParams});
        }
        if(value == 'answer'){
            sqlParams['wtda']='wtda is not null'
            this.setState({sqlParams:sqlParams})
        }
        if(value == 'unanswer'){
            sqlParams['wtda']='wtda is null'
            this.setState({sqlParams:sqlParams})
        }
    }
    //自定义下拉框查询
    zdySearchFieldChange = (value) => {
        this.setState({
            searchField: value
        });
        if (value && this.state.searchText) {
            let searchText = this.state.searchText;
            let searchParams = {};
            searchParams[value] = searchText;
            this.setState({
                searchParams: searchParams
            })
        } else {
            this.setState({
                searchParams: {}
            })
        }
    }
    //搜索操作
    onSearch = () => {
        this.filterData();
    }
    //输入框
    zdySearchTextChange = (e) => {
        this.setState({
            searchText: e.target.value
        });
        if (e.target.value && this.state.searchField) {
            let searchParams = {};
            searchParams[this.state.searchField] = e.target.value;
            this.setState({
                searchParams: searchParams
            });
        } else {
            this.setState({
                searchParams: {}
            })
        }
    }



    render() {



        const { clientHeight, spinLoading, spinTip, wtfl  } = this.state;

        const ListContent = ({ data: { WTDA, HDSJ, HDR } }) => (
            <div>
              <div style={{whiteSpace: 'normal'}} dangerouslySetInnerHTML={{__html: WTDA}} />
              {WTDA ?
              <div>
                <span style={{color:'#40A9FF'}}>{HDR}</span> 回答于
                <em>{moment(HDSJ).format('YYYY-MM-DD HH:mm')}</em>
              </div>
              : <div style={{color:'red'}}>问题暂未回答！</div>
            }
            </div>
          );


          const wtfls = [];
          if(wtfl){
            wtfl.map((item,index)=>{
                wtfls.push (
                    <Option key={index} value={item.VALUE}>{item.LABEL}</Option>
                )
            })
          }


          const formItemLayout = {
            wrapperCol: {
              xs: { span: 24 },
              sm: { span: 24 },
              md: { span: 12 },
            },
          };

        return (
            <div className={css.main_right_content} style={{height:getSize().windowH-163}}>
                <div className={css.search_box}>
                    <label title="问题是否已回答" style={{ paddingLeft: 5 }}>问题是否已回答：</label>
                    <Select
                        style={{ border:'1px' }}
                        defaultValue="multiField"
                        onChange={this.SearchFieldChange}
                        dropdownMatchSelectWidth={false}
                        dropdownStyle={{width:'100px'}}
                    >
                        <Option value="multiField">全部</Option>
                        <Option value="answer">已回答</Option>
                        <Option value="unanswer">未回答</Option>
                    </Select>
                    <Divider type="vertical" />
                    <label title="问题分类" style={{ paddingLeft: 5 }}>问题分类：</label>
                    <Select
                        style={{ border:'1px' }}
                        defaultValue="multiField"
                        onChange={this.wtflSearchFieldChange}
                        dropdownMatchSelectWidth={false}
                        dropdownStyle={{width:'100px'}}
                    >
                        <Option value="multiField">全部</Option>
                        {wtfls}
                    </Select>
                    <Divider type="vertical" />
                    <Select
                        style={{ paddingLeft: 5  }}
                        defaultValue="multiField,wt,twbm"
                        onChange={this.zdySearchFieldChange}
                        dropdownMatchSelectWidth={false}
                        dropdownStyle={{width:'100px'}}
                    >
                        <Option value="multiField,wt,twbm">全部</Option>
                        <Option value="wt">问题</Option>
                        <Option value="twbm">提问院系</Option>
                    </Select>
                    <Search
                        onSearch={this.onSearch}
                        value={this.state.searchText}
                        onChange={this.zdySearchTextChange}
                        placeholder="请输入查询条件"
                        style={{ width: 230 }}
                    />
                    <Button type="primary" style={{ margin: '0 20px' }} onClick={this.onSearch}>查询</Button>
                    <Button type="Default" style={{ paddingLeft: 5 }} icon="reload" onClick={this.onRest} >重置</Button>
                </div>
                <Spin spinning={spinLoading} tip={spinTip} size={'default'} >
                <Scrollbars autoHide style={{ width: '100%', height: clientHeight - 336 , top:'16px'}}>
                       <List
                            ref="nhlist"
                            size="large"
                            rowKey="id"
                            itemLayout="vertical"
                            dataSource={this.state.data}
                            renderItem={item => (
                            <List.Item
                                key={item.id}
                                actions={[
                                    <span onClick={() =>this.handleUpdateBtnClick(item.PKID)}>
                                    <Icon type="edit" style={{ marginRight: 8 }}/>
                                    {item.WTDA?'修改回答':'回答问题'}
                                    </span>,
                                    <span onClick={() =>this.handleSettingBtnClick(item.PKID)}>
                                    <Icon type="setting" style={{ marginRight: 8 }}/>
                                    {'问题设置'}
                                    </span>,
                                     <span onClick={() =>this.deleteWt(item.PKID)}>
                                     <Icon type="delete" style={{ marginRight: 8 }}/>
                                     {'删除问题'}
                                     </span>
                                ]}
                            >
                                <List.Item.Meta
                                title={<div>
                                        <div style={{whiteSpace: 'normal'}} dangerouslySetInnerHTML={{__html: item.WT}} />
                                    </div>
                                }
                                description={
                                    <span>
                                    {item.WTFL ? <Tag color="blue">{item.WTFL}</Tag> : undefined}
                                    {item.WTLX ? <Tag color="blue">{item.WTLX}</Tag> : undefined}
                                    </span>
                                }
                                />
                                <ListContent data={item} />
                            </List.Item>
                            )}
                        />
                </Scrollbars>
                <div style={{ textAlign: 'right',marginTop:'32px' }}>
                    <Pagination showSizeChanger showQuickJumper onShowSizeChange={this.onShowSizeChange} onChange={this.onShowSizeChange}
                        showTotal={(total, range) => `当前${range[0]}-${range[1]}条  总数${total}条`} size={'small'} pageSizeOptions={this.state.pageSizeOptions}
                        defaultCurrent={this.state.pageData.page} defaultPageSize={this.state.pageData.pageSize} total={this.state.pageData.total} />
                </div>
                <NHModal ref="nhUpdateModal"
                         title="回答问题"
                         onOk={this.handleSaveUpdate}
                         width={800}
                >
                    <EditForm ref="nhUpdateForm" initFormData={this.state.formInitData} getContent={this.getContent}/>
                </NHModal>
                <NHModal ref="nhSettingModal"
                         title="问题设置"
                         onOk={this.handleSettingUpdate}
                >
                    <SettingForm ref="nhSettingForm" initFormData={this.state.formInitData}/>
                </NHModal>
                </Spin>
            </div>
        );
    }
}
export default ZxwdTab;



// WEBPACK FOOTER //
// ./components/fwwgl/zxwd/ZxwdTab.js